import { Component, Inject, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { OrderShuttleBusService } from '../../../../../services/ordershuttlebus.service';
import { BusService } from '../../../../../services/bus.service';
import { MatDialogRef } from '@angular/material/dialog';
import { PlannedShuttleBuss } from '../../../../../models/ShuttleBookingModel';
import { BusVM } from '../../../../../models/BusModel';
import { UserVM } from '../../../../../models/UserModel';

@Component({
  selector: 'app-back-office24-ordershuttlebus-edit',
  templateUrl: './back-office24-ordershuttlebus-edit.component.html',
  styleUrl: './back-office24-ordershuttlebus-edit.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderShuttlebusEditComponent implements OnInit, OnDestroy {
  editOrderShuttleBusForm: UntypedFormGroup;
  isDisabled = true;
  startDate: string;
  startTime: string;
  buses: BusVM[] = [];
  busDrivers: UserVM[] = [];
  organizationId: string = 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';

  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public orderShuttleBusVM: PlannedShuttleBuss,
    private fb: UntypedFormBuilder,
    public snackBar: MatSnackBar,
    public orderShuttleBusService: OrderShuttleBusService,
    public busService: BusService,
    public datepipe: DatePipe,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<BackOffice24OrderShuttlebusEditComponent>,
  ) { }

  ngOnInit(): void {
    this.getBuses();
    this.initEmptyEditOrderShuttleBusForm();
  }

  initEmptyEditOrderShuttleBusForm() {
    this.editOrderShuttleBusForm = this.fb.group({
      busId: [''],
      driverUserId: [''],
      startDate: [''],
      startTime: [''],
    });
  }

  initEditOrderShuttleBusForm() {
    alert(this.orderShuttleBusVM.startDate.toString());

    this.editOrderShuttleBusForm = this.fb.group({
      orderShuttleBusId: [this.orderShuttleBusVM.orderShuttleBusId],
      busId: [this.orderShuttleBusVM.busId],
      driverUserId: [this.orderShuttleBusVM.driverUserId],
      startDate: [this.datepipe.transform(this.orderShuttleBusVM.startDate.toString(), 'yyyy-MM-dd')],
      startTime: [this.datepipe.transform(this.orderShuttleBusVM.startDate.toString(), 'HH:mm')],
    });

    const listChange = this.editOrderShuttleBusForm.valueChanges;
    listChange
      .pipe(debounceTime(1000))
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((change: PlannedShuttleBuss) => {
        this.orderShuttleBusVM = change;
        this.isDisabled = false;
        this.snackBar.open(`Du har gjort ändringar, glöm inte att spara`, 'Tack!', {
          verticalPosition: 'top',
          duration: 2000
        });
      });
  }

  editOrderShuttleBus() {
    this.setSaveData();
    this.orderShuttleBusService
      .editOrderShuttleBus(this.editOrderShuttleBusForm.value)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(orderShuttleBusVM => {
        this.snackBar.open('Bussrutten är ändrad', 'OK', {
          verticalPosition: 'top',
          duration: 2000
        });
        this.dialogRef.close(orderShuttleBusVM);
      },
        error => {
          this.snackBar.open(`Felkod: ${error.status}`, 'Doh!', {
            verticalPosition: 'top'
          });
        }
      );
  }

  setSaveData() {
    this.startDate = this.datepipe.transform(this.editOrderShuttleBusForm.controls['startDate'].value, 'yyyy-MM-dd');
    this.startTime = this.editOrderShuttleBusForm.controls['startTime'].value;
    this.editOrderShuttleBusForm.patchValue({
      startDate: this.startDate + 'T' + this.startTime,
    });
  }

  getBuses() {
    this.busService
      .getBuses()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(busVMs => {
        this.buses = busVMs;
        this.getBusDrivers();

      });
  }

  getBusDrivers() {
    this.busService
      .getBusDrivers(this.organizationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(userVMs => {
        this.busDrivers = userVMs;
        this.initEditOrderShuttleBusForm();
      });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
